import { FC } from 'react';
import { ImageContainer } from './styled';

interface Props {
  src?: string | null;
}

const ProductImage: FC<Props> = ({ src }) => {
  if (!src) {
    return null;
  }
  return (
    <ImageContainer>
      <img src={src} alt="product" />
    </ImageContainer>
  );
};

export default ProductImage;
